<template>
  <div id="exchangeSuccessRoot">
    <div id="exchangeSuccessDiv">
      <div id="exTitleDiv">
      兑换成功
      </div>
      <div id="exClose" @click="onBackClick()">x</div>
      <div id="exContentDiv">
        <!-- 请关注公众号“久立游戏”并在公众号提现功能里输入以下验证码进行提现 -->
        <span v-if="exchangeSuccessItem != null">{{exchangeSuccessItem['show']}}</span>
      </div>
      <button class="copyCode" @click="copyCode()">复制验证码</button>
    </div>
  </div>
</template>

<script>
 export default {
  props:{
    exchangeSuccessItem: null,
  },
   data () {
     return {
     }
   },
   components: {
   },
  methods:{
    // 隐藏兑换记录页面
    onBackClick(){
      this.$emit("hideexchangesuccesspage");
    },
    copyCode(){
      var obj = {"content":this.exchangeSuccessItem["token"], "toastMsg": "验证码复制成功"};
      this.sendToClient('copyClick?'+JSON.stringify(obj))
    }
  },
 }
</script>

<style>
#exchangeSuccessRoot{
  /* background-color: aquamarine; */
  width: 100%;
  height: 70vh;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  background: rgba(51,51,51,0.5);
  z-index: 2233;
}
#exClose{
  z-index: 2233;
  width: 25px;
  height: 25px;
  line-height: 25px;
  background-color: #E6E6E6;
  float: right;
  position: absolute;
  top: -12px;
  right: -10px;
  text-align: center;
  border-radius: 25px;
  color: #484848;
}
#exchangeSuccessDiv{
  background-color: white;
  border-radius:10px;
  z-index: 2000;
  width: 90%;
  height: 200px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  
}
#exTitleDiv{
  margin-top: 10px;
  background-color: white;
  color: #3E3E3E;
  font-size: small;
  font-weight: bold;
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  /* border-bottom: 1px solid #B4B4B4; */
}
#exContentDiv{
  width: 96%;
  height: 120px;
  /* background-color: aquamarine; */
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 4%;
}
#exchangeSuccessDiv button{
  position: absolute;
  bottom: 5%;
  width: 60%;
}
</style>


// WEBPACK FOOTER //
// src/views/SdkV3/mine/rebateTypeMoney/cashout/ExchangeSuccess.vue